import React from 'react';
import styled from 'styled-components';
import SvgIcon from '@components/SvgIcon';

const IconRZ = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M7 8v2H4.714c.652 1.215 1.69 2 2.857 2 1.728 0 3.17-1.717 3.5-4h.878c-.346 3.393-2.43 6-4.949 6-1.636 0-3.088-1.1-4-2.8V14H1V8h6zm5.5-2a.5.5 0 110 1h-4a.5.5 0 010-1h4zm-11 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zM7 0c2.265 0 4.178 2.109 4.793 5h-.947c-.551-1.766-1.81-3-3.275-3-1.464 0-2.723 1.234-3.274 3h-2.09C2.822 2.11 4.735 0 7 0z"
          id="s-rz_svg__a"
        />
      </defs>
      <g transform="translate(2 1)" fill="none" fillRule="evenodd">
        <mask id="s-rz_svg__b" fill="#fff">
          <use xlinkHref="#s-rz_svg__a" />
        </mask>
        <use fill="#D8D8D8" xlinkHref="#s-rz_svg__a" />
        <path fill={color} mask="url(#s-rz_svg__b)" d="M-6-5h25v25H-6z" />
      </g>
    </>
  ),
})``;

export default IconRZ;
